export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_AUTH_URL || 'http://localhost:8081',
  DATA_URL: process.env.REACT_APP_DATA || 'http://localhost:8082',
  // Отдельная переменная для URL обновления токена - для деплоя нужно будет изменить только это значение
  REFRESH_URL: process.env.REACT_APP_REFRESH_URL || 'http://localhost:8081/api/auth/refresh',
  ENDPOINTS: {
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',
    REFRESH: '/api/auth/refresh',
    LOGOUT: '/api/auth/logout',
    PROFILE: '/api/auth/profile',
    ME: '/api/auth/me', // Исправлено согласно curl запросу
    REQUESTS: '/api/requests',
    REQUESTS_BY_RESPONSIBLE: '/api/requests/responsible',
    REQUESTS_BY_USER: '/api/requests/user',
    REQUESTS_TAKE_IN_WORK: '/api/requests',
    REQUESTS_COMPLETE: '/api/requests',
    REQUESTS_ACTIVE: '/api/requests/user',
    FLIGHTS: '/api/flights',
    CARS: '/api/cars',
    CAR_BY_ID: '/api/cars',
    STATUSES: '/api/statuses',
    USERS: '/api/users',
    CALIBRATION_TABLES: '/api/calibration-tables'
  },
  HEADERS: {
    'Content-Type': 'application/json',
    'accept': '*/*'
  }
};

export const getApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

export const getDataApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.DATA_URL}${endpoint}`;
}; 